import validate from "/home/runner/work/tensormap/tensormap/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.5.1_@types+node@22.15.29_db0@0.3.2_ioredis@5.6.1_magicast_c01f6c8e991f705b7886c992f2e8e33b/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45base_45auth_45global from "/home/runner/work/tensormap/tensormap/node_modules/.c12/gh_NMGResources_Inc_m1qd2z8deW/middleware/01.base-auth.global.js";
import _001_45auth_45global from "/home/runner/work/tensormap/tensormap/middleware/001.auth.global.ts";
import previous_45route_45global from "/home/runner/work/tensormap/tensormap/middleware/previousRoute.global.ts";
import manifest_45route_45rule from "/home/runner/work/tensormap/tensormap/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.5.1_@types+node@22.15.29_db0@0.3.2_ioredis@5.6.1_magicast_c01f6c8e991f705b7886c992f2e8e33b/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45base_45auth_45global,
  _001_45auth_45global,
  previous_45route_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "auth-required": () => import("/home/runner/work/tensormap/tensormap/node_modules/.c12/gh_NMGResources_Inc_m1qd2z8deW/middleware/auth-required.js")
}